import { useMemo } from 'react';
import type { DocumentUpload } from '@gcv/shared';
import { useQuery } from '@tanstack/react-query';

import { DocumentsApi } from 'api';
import { useUser } from 'hooks/queries';
import { getObjectMap } from 'util/objectUtils';
import { BANK_DOCUMENTS_KEY } from '../../keys';

export function useBankDocuments({ shouldNotifyOnChange = true }: { shouldNotifyOnChange?: boolean } = {}) {
  const documentsApi = new DocumentsApi();
  const { userBankId } = useUser();

  const { data: bankDocumentsData, isLoading: isLoadingBankDocuments } = useQuery({
    enabled: !!userBankId,
    queryKey: [BANK_DOCUMENTS_KEY, userBankId],
    queryFn: () => documentsApi.getDocuments(userBankId),
    ...(!shouldNotifyOnChange && { notifyOnChangeProps: [] })
  });

  const { bankDocumentsMap } = useMemo(() => {
    if (!bankDocumentsData) return { bankDocumentMap: {} };

    const bankDocumentsMap: { [id: string]: DocumentUpload } = getObjectMap(bankDocumentsData, 'id');

    return { bankDocumentsMap };
  }, [bankDocumentsData]);

  return { bankDocumentsData, bankDocumentsMap, isLoadingBankDocuments };
}
